import cn from 'classnames';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { BodyM } from 'components/domains/typography/Typography';

import type { NotificationProps as NotificationType } from 'redux-store/slices/notifications/types';

import { NotificationsSlice } from '../../../../redux-store/slices/notifications';

import styles from './styles.module.scss';

enum ImageEnum {
  error = 'fail.svg',
  success = 'success.svg',
  info = 'info.svg',
}

export const Notification: React.FC<NotificationType> = ({
  title,
  type,
  body,
  className,
  id,
}) => {
  const image = ImageEnum[type];
  const dispatch = useDispatch();
  const [timeoutId, setTimeoutId] = useState<null | number>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(NotificationsSlice.actions.close({ id }));
    }, 5 * 1000) as never;

    setTimeoutId(timeout);

    return () => {
      clearTimeout(timeoutId as never);
    };
  }, []);

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.left}>
        <Image
          className={styles.icon}
          src={`/pagesImages/Notifications/${image}`}
          width={20}
          height={20}
        />
      </div>
      <div className={cn(styles.right, { [styles.noBody]: !body })}>
        <BodyM className={styles.title}>{title}</BodyM>
        <BodyM className={styles.body}>{body}</BodyM>
      </div>
    </div>
  );
};
